const photos =  {
  "4\" x 6\"" : {
    photo_1: {
      width: 100,
      height: 100 * (4/6),
      left: 0,
      top: 0,
    },
    photo_2: {
      width: 100,
      height: 100 * (4/6),
      left: 110,
      top: 0,
    },
    photo_3: {
      width: 100,
      height: 100 * (4/6),
      left: 220,
      top: 0,
    },
    photo_4: {
      width: 100,
      height: 100 * (4/6),
      left: 330,
      top: 0,
    },
    photo_5: {
      width: 100,
      height: 100 * (4/6),
      left: 440,
      top: 0,
    },
    photo_6: {
      width: 100,
      height: 100 * (4/6),
      left: 0,
      top: 110,
    },
    photo_7: {
      width: 100,
      height: 100 * (4/6),
      left: 110,
      top: 110,
    },
    photo_8: {
      width: 100,
      height: 100 * (4/6),
      left: 220,
      top: 110,
    },
    photo_9: {
      width: 100,
      height: 100 * (4/6),
      left: 330,
      top: 110,
    },
    photo_10: {
      width: 100,
      height: 100 * (4/6),
      left: 440,
      top: 110,
    },
    photo_11: {
      width: 100,
      height: 100 * (4/6),
      left: 0,
      top: 220,
    },
    photo_12: {
      width: 100,
      height: 100 * (4/6),
      left: 110,
      top: 220,
    },
    photo_13: {
      width: 100,
      height: 100 * (4/6),
      left: 220,
      top: 220,
    },
    photo_14: {
      width: 100,
      height: 100 * (4/6),
      left: 330,
      top: 220,
    },
    photo_15: {
      width: 100,
      height: 100 * (4/6),
      left: 440,
      top: 220,
    },
    photo_16: {
      width: 100,
      height: 100 * (4/6),
      left: 0,
      top: 330,
    },
    photo_17: {
      width: 100,
      height: 100 * (4/6),
      left: 110,
      top: 330,
    },
    photo_18: {
      width: 100,
      height: 100 * (4/6),
      left: 220,
      top: 330,
    },
    photo_19: {
      width: 100,
      height: 100 * (4/6),
      left: 330,
      top: 330,
    },
    photo_20: {
      width: 100,
      height: 100 * (4/6),
      left: 440,
      top: 330,
    }
  },
  "6\" x 4\"" : {
    photo_1: {
      width: 100 * (4/6),
      height: 100,
      left: 0,
      top: 0,
    },
    photo_2: {
      width: 100 * (4/6),
      height: 100,
      left: 110,
      top: 0,
    },
    photo_3: {
      width: 100 * (4/6),
      height: 100,
      left: 220,
      top: 0,
    },
    photo_4: {
      width: 100 * (4/6),
      height: 100,
      left: 330,
      top: 0,
    },
    photo_5: {
      width: 100 * (4/6),
      height: 100,
      left: 440,
      top: 0,
    },
    photo_6: {
      width: 100 * (4/6),
      height: 100,
      left: 0,
      top: 110,
    },
    photo_7: {
      width: 100 * (4/6),
      height: 100,
      left: 110,
      top: 110,
    },
    photo_8: {
      width: 100 * (4/6),
      height: 100,
      left: 220,
      top: 110,
    },
    photo_9: {
      width: 100 * (4/6),
      height: 100,
      left: 330,
      top: 110,
    },
    photo_10: {
      width: 100 * (4/6),
      height: 100,
      left: 440,
      top: 110,
    },
    photo_11: {
      width: 100 * (4/6),
      height: 100,
      left: 0,
      top: 220,
    },
    photo_12: {
      width: 100 * (4/6),
      height: 100,
      left: 110,
      top: 220,
    },
    photo_13: {
      width: 100 * (4/6),
      height: 100,
      left: 220,
      top: 220,
    },
    photo_14: {
      width: 100 * (4/6),
      height: 100,
      left: 330,
      top: 220,
    },
    photo_15: {
      width: 100 * (4/6),
      height: 100,
      left: 440,
      top: 220,
    },
    photo_16: {
      width: 100 * (4/6),
      height: 100,
      left: 0,
      top: 330,
    },
    photo_17: {
      width: 100 * (4/6),
      height: 100,
      left: 110,
      top: 330,
    },
    photo_18: {
      width: 100 * (4/6),
      height: 100,
      left: 220,
      top: 330,
    },
    photo_19: {
      width: 100 * (4/6),
      height: 100,
      left: 330,
      top: 330,
    },
    photo_20: {
      width: 100 * (4/6),
      height: 100,
      left: 440,
      top: 330,
    }
  }

};
export default photos;
